export default __webpack_public_path__ + "static/media/Albamoda_10.0671311d.png";